export default __webpack_public_path__ + "static/media/nr2.0131bf91.svg";